import React from "react";
import SignalWifi0BarIcon from "@material-ui/icons/SignalWifi0Bar";
import SignalWifi1BarIcon from "@material-ui/icons/SignalWifi1Bar";
import SignalWifi2BarIcon from "@material-ui/icons/SignalWifi2Bar";
import SignalWifi3BarIcon from "@material-ui/icons/SignalWifi3Bar";
import SignalWifi4BarIcon from "@material-ui/icons/SignalWifi4Bar";

export const WifiIcon = React.memo(({ signalLevel = 0 }) => {
  return (
    <>
      {signalLevel === 0 && <SignalWifi0BarIcon color="primary" />}
      {signalLevel > 0 && signalLevel <= 25 && (
        <SignalWifi1BarIcon color="primary" />
      )}
      {signalLevel > 25 && signalLevel <= 50 && (
        <SignalWifi2BarIcon color="primary" />
      )}
      {signalLevel > 50 && signalLevel <= 75 && (
        <SignalWifi3BarIcon color="primary" />
      )}
      {signalLevel > 75 && signalLevel <= 100 && (
        <SignalWifi4BarIcon color="primary" />
      )}
    </>
  );
});
